/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Empty_Popular_CategoriesInputs */

const en_directory_empty_popular_categories = /** @type {(inputs: Directory_Empty_Popular_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular categories`)
};

const zh_directory_empty_popular_categories = /** @type {(inputs: Directory_Empty_Popular_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门分类`)
};

/**
* | output |
* | --- |
* | "Popular categories" |
*
* @param {Directory_Empty_Popular_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_empty_popular_categories = /** @type {((inputs?: Directory_Empty_Popular_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Empty_Popular_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_empty_popular_categories(inputs)
	return zh_directory_empty_popular_categories(inputs)
});
export { directory_empty_popular_categories as "directory.empty.popular_categories" }